/**
 * 本地缓存类
 */
 class LocalCache {
  setCache(key, value) {
    window.localStorage.setItem(key, JSON.stringify(value))
  }

  getCache(key) {
    const value = window.localStorage.getItem(key)
    if (value === '' || value === null) {
        return value
    }
    return value.startsWith('{') ? JSON.parse(value) : value

  }

  deleteCache(key) {
    window.localStorage.removeItem(key)
  }

  clearCache() {
    window.localStorage.clear()
  }
}

// 导出时直接创建类的实例
export default new LocalCache()